module.exports = __webpack_public_path__ + "static/media/magic-board.8d5ff98d.jpg";